import styled, { css } from 'styled-components'

import { _XS_Medium, mainColors } from '@avantstay/backoffice-core'

import { ChannelTone } from '../../StayTimeline.types'

const toneInk = {
  sms: css`
    color: ${mainColors.neutralExtremelyDark2};
  `,
  other: css`
    color: ${mainColors.primaryMedium};
  `,
  voyage: css`
    color: ${mainColors.primaryMedium};
  `,
  email: css`
    color: ${mainColors.neutralExtremelyDark2};
  `,
  chat: css`
    color: ${mainColors.neutralExtremelyDark2};
  `,
  ota: css`
    color: ${mainColors.neutralExtremelyDark2};
  `,
  push: css`
    color: ${mainColors.neutralExtremelyDark2};
  `,
  call: css`
    color: ${mainColors.primaryMedium};
  `,
}

export const Root = styled.span<{ $tone: ChannelTone }>`
  ${_XS_Medium};
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: none;
  ${({ $tone }) => toneInk[$tone]};

  svg {
    width: 12px;
    height: 12px;
    flex: none;
  }
`
